import { AES, enc } from "crypto-js";
import { captcha_secret } from './../config.json'
export const decrypt = (ciphertext) => {
	var bytes  = AES.decrypt(ciphertext, captcha_secret);
	var decryptedData = JSON.parse(bytes.toString(enc.Utf8));
	return decryptedData;
}